const GEOJS_IP_URL = "https://get.geojs.io/v1/ip.json";
const GEOJS_GEO_BY_IP_BASE_URL = "https://get.geojs.io/v1/ip/geo";
const DEFAULT_TIMEOUT_MS = 4000;
function trimNonEmpty(v) {
    if (typeof v !== "string")
        return undefined;
    const t = v.trim();
    return t.length > 0 ? t : undefined;
}
/**
 * Best-effort IP / region / city for LSQ Lead fields (mx_IP_Address, mx_State, mx_City).
 * Uses geojs (CSP-allowlisted on web); failures return `{}` so callers never block signup.
 */
export async function fetchGeoForLsqLead(timeoutMs = DEFAULT_TIMEOUT_MS) {
    if (typeof fetch !== "function")
        return {};
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), timeoutMs);
    try {
        const ipRes = await fetch(GEOJS_IP_URL, {
            signal: controller.signal,
            credentials: "omit",
        });
        if (!ipRes.ok)
            return {};
        const ipData = (await ipRes.json());
        const ip = trimNonEmpty(ipData.ip);
        if (!ip)
            return {};
        const geoRes = await fetch(`${GEOJS_GEO_BY_IP_BASE_URL}/${encodeURIComponent(ip)}.json`, {
            signal: controller.signal,
            credentials: "omit",
        });
        if (!geoRes.ok)
            return {};
        const data = (await geoRes.json());
        //console.log("fetchGeoForLsqLead", data);
        return {
            ip: trimNonEmpty(data.ip) ?? ip,
            region: trimNonEmpty(data.region),
            city: trimNonEmpty(data.city),
        };
    }
    catch {
        return {};
    }
    finally {
        clearTimeout(timer);
    }
}
